module.exports = __webpack_public_path__ + "static/media/study 201110.66213cc1.png";